let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("68z6o")).then(() => parcelRequire('hZT3b'));